import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon, XIcon } from 'lucide-react';
export function ProblemSection() {
  return <>
      <Section background="white" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-4" data-id="element-110">
            Para quién es esto (y para quién no)
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-12" data-id="element-111">
          {/* For You */}
          <div className="bg-[#FDF8F0] p-8 rounded-2xl border border-[#E8EDE6]" data-id="element-112">
            <h3 className="text-2xl text-[#2D3B2D] mb-6 flex items-center" data-id="element-113">
              <span className="bg-[#A8B5A0] text-white rounded-full p-1 mr-3" data-id="element-114">
                <CheckIcon size={20} data-id="element-115" />
              </span>
              Esto es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-116">
              <li className="flex items-start text-[#4A5D4A]" data-id="element-117">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-118" />
                Tienes 2–8 deudas (tarjetas, préstamos) y sientes que "todo está
                encima"
              </li>
              <li className="flex items-start text-[#4A5D4A]" data-id="element-119">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-120" />
                Pagas mínimos y te frustra que no baje
              </li>
              <li className="flex items-start text-[#4A5D4A]" data-id="element-121">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-122" />
                Evitas mirar porque te da ansiedad o vergüenza
              </li>
              <li className="flex items-start text-[#4A5D4A]" data-id="element-123">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-124" />
                Has intentado "presupuestar" y lo abandonas a los 3 días
              </li>
              <li className="flex items-start text-[#4A5D4A]" data-id="element-125">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-[#2D3B2D] rounded-full flex-shrink-0" data-id="element-126" />
                Compras impulsivamente cuando estás estresada y luego te culpas
              </li>
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-white p-8 rounded-2xl border border-gray-100" data-id="element-127">
            <h3 className="text-2xl text-[#2D3B2D] mb-6 flex items-center" data-id="element-128">
              <span className="bg-gray-300 text-white rounded-full p-1 mr-3" data-id="element-129">
                <XIcon size={20} data-id="element-130" />
              </span>
              Esto NO es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-131">
              <li className="flex items-start text-gray-600" data-id="element-132">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-133" />
                Buscas un milagro o promesas irreales
              </li>
              <li className="flex items-start text-gray-600" data-id="element-134">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-135" />
                Quieres asesoría legal/financiera personalizada (esto es
                educativo)
              </li>
              <li className="flex items-start text-gray-600" data-id="element-136">
                <span className="mr-3 mt-1.5 h-1.5 w-1.5 bg-gray-400 rounded-full flex-shrink-0" data-id="element-137" />
                No estás dispuesta a mirar tus números por 30 minutos (aunque
                incomode)
              </li>
            </ul>
          </div>
        </div>
      </Section>

      <Section background="sage" className="text-center" data-id="element-138">
        <div className="max-w-3xl mx-auto" data-id="element-139">
          <h2 className="text-3xl md:text-4xl text-[#2D3B2D] mb-8" data-id="element-140">
            El problema no es que seas{' '}
            <span className="italic text-[#2D3B2D]/80" data-id="element-141">
              "mala con el dinero"
            </span>
          </h2>
          <div className="space-y-6 text-lg text-[#2D3B2D]/90 leading-relaxed" data-id="element-142">
            <p data-id="element-143">
              El problema es que estás intentando resolver algo emocionalmente
              pesado con herramientas frías.
            </p>
            <p data-id="element-144">
              Las hojas de Excel no te calman. Los "tips" de TikTok no te
              sostienen cuando estás agotada. Y la disciplina como castigo… solo
              dura hasta que el mes se pone feo.
            </p>
            <p data-id="element-145">
              Cuando estás estresada, tu cerebro quiere una cosa: alivio rápido.
              Y adivina qué da alivio rápido: no mirar… o comprar algo.
            </p>
            <div className="bg-[#FDF8F0] p-6 rounded-xl inline-block mt-4 shadow-sm" data-id="element-146">
              <p className="font-medium text-[#2D3B2D]" data-id="element-147">
                No es falta de carácter. Es falta de un sistema de decisiones
                cerradas.
              </p>
            </div>
          </div>
        </div>
      </Section>
    </>;
}